/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useState } from 'react'
import {
  ControlProps,
  RankedTester,
  rankWith,
  isNumberControl
} from '@jsonforms/core'

import { withJsonFormsControlProps } from '@jsonforms/react'
import { Form } from 'react-bootstrap'

export const NumberControl = (props: ControlProps) => {
  const {
    label,
    handleChange,
    data,
    errors,
    path,
    id,
    schema,
    uischema,
    required,
    enabled
  } = props
  const [showError, setShowError] = useState<boolean>(false)
  const errMsgs = ['should be number', 'is a required property']
  const getClass = () => {
    return errors && errMsgs.includes(errors)
      ? 'form-control is-invalid'
      : 'form-control'
  }

  const validate = () => {
    required && !data ? setShowError(true) : setShowError(false)
  }

  return (
    <>
      <Form.Group>
        <Form.Label htmlFor={id} className='custom-input-label'>
          {label}
        </Form.Label>
        <Form.Control
          type='number'
          className={getClass()}
          value={data}
          id={id}
          onChange={(ev: any) => {
            const val = ev.target.value
            const maxLength = (uischema as any).maxLength || 15
            const newValue =
              val < maxLength
                ? val
                : parseInt(val.toString().substring(0, maxLength))
            handleChange(path, newValue)
          }}
          onBlur={() => {
            validate()
          }}
          disabled={!enabled}
          data-testid='custom-number-input'
        />
        {(!!errors || showError) && (
          <div className='text-danger' data-testid='error-message-div'>
            {(uischema as any).requiredErrorLabel && (
              <span>{(uischema as any).requiredErrorLabel}</span>
            )}
            {!(uischema as any).requiredErrorLabel && (
              <span>{`${schema.title} is required`}</span>
            )}
          </div>
        )}
      </Form.Group>
    </>
  )
}

export const numberControlTester: RankedTester = rankWith(5, isNumberControl)
export default withJsonFormsControlProps(NumberControl)
